import moment from "moment";

export const history = require("history").createBrowserHistory({});

export const debounce = (cb, delay = 1000) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      cb(...args);
    }, delay);
  };
};

export const TextGenerator = (text = "") => {
  return text
    .split(/(\d+-)/)
    .map((t, index, arr) => {
      if (index % 2 === 0) {
        return t.replace(/-/g, " ");
      } else {
        return t;
      }
    })
    .join(" ");
};
export const formatKey = (key) => {
  return key
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (str) => str.toUpperCase());
};

export const capitalizeWords = (str) => {
  return str.replace(/\b\w/g, (char) => char.toUpperCase())
}

export const isValidDate = (date) => {
  return moment(date, "YYYY-MM-DD", true).isValid();
};

// Function to get the start and end dates for the preceding period

export const getPrecedingPeriodMatchDayOftheWeek = (start, end) => {
  const currentStartDate = moment(start)
  const currentEndDate = moment(end)

  if (!currentStartDate.isValid() || !currentEndDate.isValid()) {
    throw new Error("Invalid date format. Please use 'YYYY-MM-DD'.")
  }

  if (currentEndDate.isBefore(currentStartDate)) {
    throw new Error("End date must be after or equal to start date.")
  }

  const durationInDays = currentEndDate.diff(currentStartDate, "days") + 1

  // Calculate initial preceding start date
  let precedingStartDate = currentStartDate
    .clone()
    .subtract(durationInDays, "days")

  // Align to the same day of week as the current start date
  if (durationInDays <= 6 && durationInDays >= 2) {
    const belowSevenDaysDiff =
      (currentStartDate.day() - precedingStartDate.day() - 7) % 7;
    precedingStartDate.add(belowSevenDaysDiff, "days");
  } else if (durationInDays <= 1) {
    if (precedingStartDate.isSame(currentStartDate, "day")) {
      precedingStartDate.subtract(1, "days");
    }
  } else {
    const daysDiff = (currentStartDate.day() - precedingStartDate.day() + 7) % 7
    precedingStartDate.add(daysDiff, "days")
  }

  // Calculate preceding end date
  const precedingEndDate = precedingStartDate
    .clone()
    .add(durationInDays - 1, "days")

  return {
    startDate: precedingStartDate.toDate(),
    endDate: precedingEndDate.toDate(),
  }
}














// Test cases
// const testCases = [
//   ["2023-12-11", "2024-12-11"],  // Standard case
//   ["2023-12-01", "2024-02-28"],  // Leap year case
//   ["2024-06-01", "2024-06-30"],  // Full month
//   ["2024-01-01", "2024-01-07"],  // One week
//   ["2024-01-01", "2024-01-05"],  // Partial week
//   ["2023-11-03", "2024-11-26"],  // Cross-year week
//   ["2024-02-28", "2024-03-01"],  // Leap year day
//   ["2024-01-01", "2024-12-31"],  // Full year
//   ["2023-01-01", "2023-12-31"],  // Full non-leap year
//   ["2024-02-29", "2024-03-01"],  // Leap day to next month
//   ["2023-02-28", "2023-03-01"],  // Non-leap year February end
//   ["2024-12-31", "2025-01-01"],  // Year transition
//   ["2024-01-01", "2025-12-31"]   // Multi-year span
// ];

// Function to get the start and end dates for the same period last year


export const getSamePeriodLastYearWithMatchdayoftheWeek = (start, end) => {

  // Parse input dates
  const currentStartDate = moment(start)
  const currentEndDate = moment(end)

  // Validate input dates
  if (!currentStartDate.isValid() || !currentEndDate.isValid()) {
    throw new Error("Invalid date format. Please use 'YYYY-MM-DD'.")
  }

  if (currentEndDate.isBefore(currentStartDate)) {
    throw new Error("End date must be after or equal to start date.")
  }

  // Calculate duration
  const durationInDays = currentEndDate.diff(currentStartDate, "days") + 1

  // Initialize last year's start date
  let lastYearStartDate = currentStartDate.clone().subtract(1, "year")

  // Align to the same day of the week
  const daysDiff = (currentStartDate.day() - lastYearStartDate.day() + 7) % 7
  lastYearStartDate.add(daysDiff, "days")

  // Calculate last year's end date
  const lastYearEndDate = lastYearStartDate
    .clone()
    .add(durationInDays - 1, "days")

  return {
    startDate: lastYearStartDate.toDate(),
    endDate: lastYearEndDate.toDate(),
  }
}

// Function to get the start and end dates for the preceding period

export const getPrecedingPeriod = (start, end) => {

  // Parse input dates
  const startDate = moment(start)
  const endDate = moment(end)

  // Validate input dates
  if (!startDate.isValid() || !endDate.isValid()) {
    throw new Error("Invalid date format. Please use 'YYYY-MM-DD'.")
  }

  if (endDate.isBefore(startDate)) {
    throw new Error("End date must be after or equal to start date.")
  }

  // Calculate duration
  const durationInDays = endDate.diff(startDate, "days") + 1

  // Calculate preceding period end date (one day before start date)
  const precedingEndDate = startDate.clone().subtract(1, "day")

  // Calculate preceding period start date
  const precedingStartDate = precedingEndDate
    .clone()
    .subtract(durationInDays - 1, "days")

  return {
    startDate: precedingStartDate.toDate(),
    endDate: precedingEndDate.toDate(),
  }
}

export const getSamePeriodLastYear = (start, end) => {

  // Parse input dates
  const startDate = moment(start)
  const endDate = moment(end)

  // Validate input dates
  if (!startDate.isValid() || !endDate.isValid()) {
    throw new Error("Invalid date format. Please use 'YYYY-MM-DD'.")
  }

  if (endDate.isBefore(startDate)) {
    throw new Error("End date must be after or equal to start date.")
  }

  // Calculate duration
  const durationInDays = endDate.diff(startDate, "days")

  // Calculate same period last year
  const lastYearStartDate = startDate.clone().subtract(1, "year")
  const lastYearEndDate = lastYearStartDate.clone().add(durationInDays, "days")

  return {
    startDate: lastYearStartDate.toDate(),
    endDate: lastYearEndDate.toDate(),
  }
}
export const getNullCase = (start, end) => {
  return {
    startDate: null,
    endDate: null,
  }
}
export const formatDateYMD = (dateString) => {
  return moment(dateString).format("YYYY-MM-DD");
};



export const formatDateRange = (startDate, endDate) => {
  const start = moment(startDate);

  if (!endDate) {
    return start.format("MMM D, YYYY"); // Return only start date if endDate is empty
  }

  const end = moment(endDate);
  const startFormat = start.format("MMM D");
  const endFormat = end.format("MMM D, YYYY");

  if (start.year() === end.year()) {
    if (start.month() === end.month()) {
      return `${startFormat}-${end.date()}, ${end.year()}`;
    } else {
      return `${startFormat} - ${endFormat}`;
    }
  } else {
    return `${start.format("MMM D, YYYY")} - ${endFormat}`;
  }
};

export const getStatusForTable = (status) => {
  const statusMap = {
    1: "Created",
    2: "Success",
    3: "Failed",
    4: "Refund",
  };

  return statusMap[status] || "-";
};

export const getStatusForPaymentStatus = (status) => {
  const statusMap = {
    1: "Created",
    2: "Success",
    3: "Failed",
    4: "Cancelled",
    5: "User Scheme Adjustment",
    6: "Refund Initiated",
    7: "Refunded",
    8: "Refund Failed",
  };

  return statusMap[status] || "-";
}
export const getInstallmentIcon = (
  installment,
  outerAutoPay,
  installmentIcons
) => {
  const { status, autoPay, paymentDate, scheduleStatus } = installment || {};
  const today = moment().startOf("day");
  const payDate = paymentDate ? moment(paymentDate).startOf("day") : null;
  console.log("scheduleStatus", scheduleStatus)
  // ✅ Scenario 1: autopay = true, status = 2 (Success)

  if (autoPay && (status === 2 || scheduleStatus === 3)) {
    return installmentIcons?.autoPaySuccess;
  }

  // ✅ Scenario 2: autopay = true, status = 3 (Failed)
  if (autoPay && scheduleStatus === 4) {
    return installmentIcons?.autoPayFailed;
  }
  // ✅ Scenario 3: autopay = false, status = 2 (Manual Pay Success)
  if (!autoPay && status === 2) {
    return installmentIcons?.manualPaySuccess;
  }


  if (autoPay && (scheduleStatus === 1 || scheduleStatus === 6)) {
    return installmentIcons?.dueDateAutoPay;
  }


  if (outerAutoPay) {
    return installmentIcons?.restOfAutoPay;
  }

  if (!outerAutoPay) {
    return installmentIcons?.restOfManualPay;
  }

  // ✅ Scenario 4: autopay = true, status=1 (Pending) and today = paymentDate


  if (
    !autoPay &&
    Number(status) === 2 &&
    payDate &&
    today.isBefore(payDate, "day")
  ) {
    return installmentIcons?.dueDateManualPay;
  }
  return null;
};
export const normalizeBoolean = (val) => {
  if (val === true || val === "true" || val === "yes") return true
  if (val === false || val === "false" || val === "no") return false
  return null
}
export const canCancelMandate = (nextPresentationDate) => {
  if (!nextPresentationDate) return false;

  const today = moment().startOf("day");
  const checkDate = moment(nextPresentationDate)
    .subtract(2, "days")
    .startOf("day");

  // const final=today > (nextPresentationDate - 2 )
  return today.isAfter(checkDate);
};

export const formatLabel = (text) =>
  text.replace(/([A-Z])/g, " $1").trim();
